import axios from "axios";
import { API_URL } from "../App";

export const fetchUserData = async () => {
  const config = {
    method: "post",
    url: API_URL + `/session`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios(config);

    if (response.data[0].error_msg) {
      throw new Error(response.data[0].error_msg);
    }

    return {
      userId: response.data[0].userId,
      user: response.data[0].user,
      permId: response.data[0].permId,
      fullName: response.data[0].fullName,
      idGrp: response.data[0].idGrp,
      grpName: response.data[0].grpName,
      expire: response.data[0].expire,
      is_active: response.data[0].is_active,
      description: response.data[0].description,
      email: response.data[0].email,
      phone: response.data[0].phone,
    };
  } catch (error) {
    //console.error("Wylogowano lub brak sesji", error);
    return null;
  }
};
